export const roles = {
	Super_User: "Super_User",
	System_Administrator: "System_Administrator",
	Case_Administrator: "Case_Administrator",
	Case_User: "Case_User",
}
